import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/@services/common.service";
import { InnerPagesService } from "src/app/pages/common-layout/inner-pages.service";
import {
  CommonResponseRecords,
  CommonResponseResult,
} from "src/models/commomnModel.model";
import { responseMessageStatus, ResponseStatus } from "../../enum";
interface Announcement {
  id: string;
  description: string;
  desc: string;
}
@Component({
  selector: "app-notifications-announcements",
  templateUrl: "./notifications-announcements.component.html",
  styleUrls: ["./notifications-announcements.component.scss"],
  standalone: false,
})
export class NotificationsAnnouncementsComponent implements OnInit {
  //#region
  visible: boolean = true;
  @Output() hideAnnouncements = new EventEmitter();
  announcements: Announcement[] = [];
  totalUnreadNotifications: number = 0;
  isDataLoading: boolean = true;
  isVisibleModal: boolean = false;
  modalTitle: string = "Notification";
  currentDescription: string = "";
  siteId: string;
  //#endregion

  constructor(
    private _iS: InnerPagesService,
    public _cS: CommonService,
    private route: ActivatedRoute
  ) {
    this.siteId = this.route.snapshot.paramMap.get("siteId");
  }

  ngOnInit(): void {
    this.getAnnouncements();
  }

  getAnnouncements() {
    this.isDataLoading = true;
    this._iS
      .getAnnouncements(this.siteId)
      .subscribe((response: CommonResponseResult<Announcement>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.announcements = response.result;
          this.totalUnreadNotifications = response.result.length;
          this.announcements.forEach((announcement: Announcement) => {
            announcement.desc = announcement.description.replace(
              /<[^>]+>/g,
              ""
            );
          });
          this.isDataLoading = false;
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
          this.isDataLoading = false;
        }
      });
  }

  close() {
    this.visible = false;
    this.hideAnnouncements.emit({
      visible: this.visible,
      notifications: this.totalUnreadNotifications,
    });
  }

  clearAllAnnouncements() {
    const announcementIds = this.announcements.map((x: any) => x.id).join();
    this._iS
      .clearAnnouncements(announcementIds)
      .subscribe((response: CommonResponseRecords<Announcement>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.announcements = [];
          this.totalUnreadNotifications = 0;
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }

  removeFromList(id: string) {
    this._iS
      .clearAnnouncements(id)
      .subscribe((response: CommonResponseRecords<Announcement>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.announcements = this.announcements.filter(
            (x: Announcement) => x.id !== id
          );
          this.totalUnreadNotifications--;
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  // handleCancel(){}
}
